// Impersonation sessions are read-only; api-client consults this flag to
// refuse mutating requests. Set during render of ImpersonationBanner — the
// root layout mounts it before any page content, so the flag is on before
// the first call site can fire. Browser-only: the server render must not
// flip a process-wide global shared across requests.
let impersonating = false;

export function markImpersonationSession(): void {
  if (typeof window === 'undefined') return;
  impersonating = true;
}

export function isImpersonationSession(): boolean {
  return impersonating;
}
